export default {
  homeCustom: {},
  homeBusi: {},
  homeContract: {},
  homeCustomVisit: {},
  homeChartData: {},
  homeProject: {},
  homeMedicalCustomer: {},
};
